import catalog from './distanceUnits.json';

export const DISTANCE_UNITS = catalog.units;
const unitsById = new Map(DISTANCE_UNITS.map((unit) => [unit.value, unit]));

export const normalizeDistanceConfig = (config) => {
  if (config.format !== 'distance') return { config: {} };
  if (!unitsById.has(config.distance_unit))
    return { error: 'Select a distance unit.' };
  return { config: { distance_unit: config.distance_unit } };
};

// Accepts an already formatted number. Unit selection never converts values.
// Legacy/incomplete metadata must not silently assign a physical unit.
export const appendDistanceUnit = (amount, config) => {
  const unit =
    config?.format === 'distance' ? unitsById.get(config.distance_unit) : null;
  return unit ? amount + ' ' + unit.symbol : amount;
};
